<div id="tabBody" class="ag-tab-body">
  <div class="ag-filter">
    <div>
      <div>
        <select class="ag-filter-select" [(ngModel)]="filterType">
          <option *ngFor="let filterType of filterTypes" [value]="filterType">{{ filterLabels[filterType] }}</option>
        </select>
      </div>
      <div class="ag-filter-body" (keydown.enter)="applyFilter()">
        <div>
          <select #dayOfWeek class="ag-filter-select" [(ngModel)]="form.dayOfWeek">
            <option selected disabled>Day of Week</option>
            <option *ngFor="let day of weekdays; let index='index'" [value]="index+1">{{ day }}</option>
          </select>
        </div>
        <div *ngIf="filterType === 'inRange'">
          <select class="ag-filter-select" [(ngModel)]="formRangeEnd.dayOfWeek">
            <option selected disabled>Day of Week</option>
            <option *ngFor="let day of weekdays; let index='index'" [value]="index+1">{{ day }}</option>
          </select>
        </div>
      </div>
      <div class="ag-filter-apply-panel" id="applyPanel">
        <button type="button" id="clearButton" (click)="clearFilter()">Clear Filter</button>
        <button type="button" id="applyButton" (click)="applyFilter()">Apply Filter</button>
      </div>
    </div>
  </div>
</div>
